<template>
    <article class="cast_article__small" @click="showModal()">
        <h3 class="cast_article--title" v-html="cast.name"></h3>
        <figure class="cast_article--image">
            <img :src="cast.image" :alt="cast.nameKanji">
        </figure>
        <button type="button" class="button_cast" name="profile"><strong>Profile/Comment</strong></button>
    </article>
</template>

<script>
export default {
    name: 'casts',
    props: {
        cast: Object
    },
    data () {
        return {
        }
    },

    methods: {
        showModal () {
            this.$emit('showModal', this.cast)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/CastsItem.vue